module.exports = __webpack_public_path__ + "static/media/aline.1b4eb43c.jpg";